var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 7.50016H13.3333M6.66667 10.8335H11.6667M15 3.3335C15.663 3.3335 16.2989 3.59689 16.7678 4.06573C17.2366 4.53457 17.5 5.17045 17.5 5.8335V12.5002C17.5 13.1632 17.2366 13.7991 16.7678 14.2679C16.2989 14.7368 15.663 15.0002 15 15.0002H10.8333L6.66667 17.5002V15.0002H5C4.33696 15.0002 3.70107 14.7368 3.23223 14.2679C2.76339 13.7991 2.5 13.1632 2.5 12.5002V5.8335C2.5 5.17045 2.76339 4.53457 3.23223 4.06573C3.70107 3.59689 4.33696 3.3335 5 3.3335H15Z",
    stroke: "#2B2B2B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.80632b521bc0a1dc39db17110d96f5e2.svg";
export { ForwardRef as ReactComponent };